import { Id_category } from './api/Identifiers'
import { QueryString } from './QueryString';

interface categoryJSON {
    "id": number,
    "desc": string,
    "level": number,
    "hierarchy": string,
    "cmsViewIcon": string
}

export function category_sort(lhs: Category, rhs: Category): number {
    if (lhs.label > rhs.label) {
        return 1;
    }
    if (lhs.label < rhs.label) {
        return -1;
    }
    return 0;
}

export class Category {
    private _root_parent: number = null;
    public is_root_parent(): boolean { return this.level === 0 }
    public get id_category(): Id_category { return Id_category.wrap(this._raw.id) };
    public get label(): string { return this._raw.desc; };
    public get heirarchy_str(): string { return this._raw.hierarchy; };
    public get root_parent(): number {
        if (this._root_parent === null) {
            let str_root: string = this._raw.hierarchy.split('\.')[1];
            let root: number = parseInt(str_root);
            if (isNaN(root)) {
                console.error("NaN encountered for root parent of " + this._raw.hierarchy)
                root = - 1;
            }
            this._root_parent = root;
        }
        return this._root_parent;
    };
    private _icon: string = "";
    public get level(): number { return this._raw.level; };
    public get icon(): string { return this._icon; };
    private _raw: categoryJSON;

    constructor(raw: categoryJSON) {
        this._raw = (<any>Object).assign({}, raw);
        this._icon = utilsAssetIcon(this._raw.cmsViewIcon);
    }
    public toJSON(): any {
        let r: any = {};
        r['parent_id'] = this.root_parent;
        r['root_parent'] = this.root_parent;
        r['level'] = this.level;
        r['desc'] = this.label;
        r['label'] = this.label;
        r['icon'] = this.icon;
        r['id_category'] = this.id_category.value;
        return r;
    }
}

export class CategoryCollection {
    private _top_level: Category[] = null;



    public static readonly empty: CategoryCollection = CategoryCollection.build_from_raw([]);

    public get length(): number { return Object.keys(this._cats).length; }

    public get id_categories_str(): string[] {
        let categories: string[] = this.id_categories.map((id: Id_category) => { return id.toString() });
        return categories;
    }

    public get id_categories(): Id_category[] {
        let categories: Id_category[] =
            Object.keys(this._cats).map((key: string) => {
                return this._cats[key].id_category;
            });
        return categories;
    }

    public get categories(): Category[] {
        let categories: Category[] = [];
        Object.keys(this._cats).forEach((key: string) => {
            categories.push(this._cats[key]);
        });
        return categories;
    }

    // returns the category specified by the id_category or null
    public find(id_category: Id_category): Category | null {
        let r: Category = this._cats[id_category.toString()];
        if (!r) {
            r = null;
        }
        return r;
    }
    public filter(id_categories: Id_category[]): CategoryCollection {
        let r = CategoryCollection.empty;
        id_categories.forEach((id_category: Id_category) => {
            let cat: Category = this.find(id_category);
            if (cat) {
                r.add(cat)
            }
        });
        return r;
    }

    public get top_level_categories(): Category[] {
        if (this._top_level === null) {
            this._top_level = [];
            Object.keys(this._cats).forEach((key: string) => {
                let cat = this._cats[key];
                if (cat.level == 0) {
                    this._top_level.push(cat)
                }
            });
        }
        return this._top_level;
    }

    public get_child_categories(category: Category): Category[] {
        let categories: Category[] = [];
        Object.keys(this._cats).forEach((key: string) => {
            let cat = this._cats[key];
            if (cat.root_parent === category.id_category.value) {
                categories.push(cat);
            }
        });
        return categories;
    }

    public static build_from_raw(raw: any): CategoryCollection {
        let r: CategoryCollection = new CategoryCollection();
        r._top_level = null;
        if (!Array.isArray(raw)) {
            // if the passed in value is not an array, we assume it's a raw categories object:
            /*
                {
                    "customerId": 1,
                    "segmentId": 11,
                    "modifiedUtc": "2017-04-14T14:15:35.593",
                    "data": [...]         <-- the catagory data
                }
                */
            raw = raw['data'];
        }
        raw.forEach((element: categoryJSON) => {
            let cat: Category = new Category(element);
            r.add(cat);
        });
        return r;
    }
    private add(category: Category): CategoryCollection {
        this._cats[category.id_category.toString()] = category;
        return this;
    }
    private _cats: {
        [key: string]: Category
    } = {};

    private constructor() {
        this._top_level = null;
    };

    public toJSON(): any {
        return JSON.parse(JSON.stringify(this._cats));
    }
}


function utilsAssetIcon(cms_view_icon: string): string {
    if (!cms_view_icon) {
        return "";
    }
    let icon: string = cms_view_icon

    if (icon.toLowerCase().substring(0, 4) !== "http") {
        icon = QueryString.storage_account_url + "/cmsview/icons/48/" + icon
    }
    return icon
}




// WEBPACK FOOTER //
// ./src/ts/Categories.ts